/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* gebruikers.module.ts
* 14-2-2020 - Jelmer Jellema - Spin in het Web B.V.
*/

import {Gebruikersscherm} from './gebruikers';
import {NgModule} from '@angular/core';
import {Gebruikeredit} from './gebruikeredit';
import {SihwDatatableModule} from 'sihw-ng/datatable/datatable.module';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {TabDirective, TabsetComponent} from 'ngx-bootstrap/tabs';

const schermen = [
  Gebruikersscherm,
  Gebruikeredit
];

@NgModule({
  declarations: schermen,
  imports: [
    CommonModule,
    SihwDatatableModule,
    FormsModule,
    TabsetComponent,
    TabDirective
  ],
  exports:schermen
}) export class GebruikersModule {}
//JIT naar AOT
Gebruikersscherm.register('Gebruikersscherm');
Gebruikeredit.register('Gebruikeredit');
